/**
 * AvatarUsuario — foto do usuário com fallback no círculo colorido com a
 * inicial (comportamento clássico). Usado na lista de usuários, no card do
 * kanban e no menu do TopNav.
 */
import { useState } from 'react';
import { AVATAR_COR } from '../utils';

interface Props {
  userId?: number | null;
  nome: string;
  corEtiqueta?: string | null;
  /** diâmetro tailwind, ex: 'w-8 h-8' (default) ou 'w-5 h-5' */
  tamanho?: string;
  texto?: string;       // ex: 'text-sm' (default) | 'text-[9px]'
  titulo?: string;
  /** força recarregar a imagem após upload (cache-bust) */
  bust?: number;
}

export function AvatarUsuario({ userId, nome, corEtiqueta, tamanho = 'w-8 h-8',
                                texto = 'text-sm', titulo, bust }: Props) {
  const [semFoto, setSemFoto] = useState(false);
  const cor = corEtiqueta ? AVATAR_COR[corEtiqueta] ?? { bg: '#6b7280', text: '#fff' }
                          : { bg: '#6b7280', text: '#fff' };

  if (userId && !semFoto) {
    return (
      <img
        src={`/api/usuarios/${userId}/avatar${bust ? `?t=${bust}` : ''}`}
        alt={nome}
        title={titulo ?? nome}
        className={`${tamanho} rounded-full object-cover flex-shrink-0 border border-black/10 dark:border-white/10`}
        onError={() => setSemFoto(true)}
      />
    );
  }
  return (
    <span
      className={`${tamanho} rounded-full flex items-center justify-center ${texto} font-bold shadow-sm flex-shrink-0`}
      style={{ background: cor.bg, color: cor.text }}
      title={titulo ?? nome}
    >
      {nome[0]?.toUpperCase()}
    </span>
  );
}
